import { Outlet } from "react-router-dom";

import { Separator } from "@krea/shared/design-system/Separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
  useSidebar,
} from "@krea/shared/design-system/sidebar";
import { cn } from "@krea/shared/utils";

import { AppSidebar } from "./sidebar-layout/app-sidebar";
import { Breadcrumbs } from "./sidebar-layout/breadcrumbs";

const MainContent = () => {
  const { isMobile, open } = useSidebar();

  return (
    <div
      id="main-content-scroll-container"
      className={cn(
        "flex min-h-0 flex-1 flex-col gap-4 p-4 pt-0 overflow-y-auto",
        !isMobile && open && "w-[calc(100vw-var(--sidebar-width)-2rem)]",
      )}
    >
      <Outlet />
    </div>
  );
};

export const LenderCompanyLayout = () => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="relative mt-2">
        <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 rounded-t-xl bg-white transition-[width,height] ease-linear">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4"
            />
            <Breadcrumbs />
          </div>
        </header>
        <MainContent />
      </SidebarInset>
    </SidebarProvider>
  );
};
